// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"XB","product":"YB","products":"ZB","tooltipWrapper":"_B","tooltip":"aC","title":"bC"};